/*
================================================================================
## 📘 SEC-01.02 Front-End IAM Client — AUTH v2 (The Bridge)
================================================================================
*/

const ENV_DOMAIN = process.env.REACT_APP_API_BASE_URL;
const DOMAIN = ENV_DOMAIN || "https://localhost:7333";
const SITE_KEY = process.env.REACT_APP_SITE_KEY;

const BASE_URL = `${DOMAIN.replace(/\/$/, "")}/api/v1/auth`;

/**
 * PURE REQUEST HELPER
 * Ensures the PascalCase string from Core passes through the BFF untouched.
 */
async function sendRequest(endpoint, payload) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    if (SITE_KEY) {
      headers.append("SITE-KEY", SITE_KEY);
    }

    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(payload),
    });

    const text = await response.text();

    if (!text) {
      return { Success: false, Message: "THere is a problem with your credentials. Please try again OR register." };
    }

    const data = JSON.parse(text);

    if (!response.ok) {
      return {
        ...data,
        Success: false,
        Status: response.status,
        Message: data.Message || data.message || `Error: ${response.status}`
      };
    }

    return data;
  } catch (err) {
    console.error("🛑 TRANSPORT CRASH:", err);
    return { Success: false, Message: "BFF/Network connection error." };
  }
}

export const coreAuthClient = {
  // 🔍 DB CONNECTIVITY PING
  async ping() {
    return sendRequest("ping", {});
  },

  // ---------------------------------------------------------------------------
  // IDENTITY FLOWS (Mapping to C# [FromBody] Models)
  // ---------------------------------------------------------------------------

  async signIn({ email, password }) {
    // Matches C# SignInRequest { Email, Password }
    return sendRequest("signin", { Email: email, Password: password });
  },

  async register({ userName, email, password }) {
    // Matches C# RegisterRequest { UserName, Email, Password }
    return sendRequest("register", {
      UserName: userName,
      Email: email,
      Password: password
    });
  },

  async verifyEmail({ verificationToken }) {
    return sendRequest("verify", { VerificationToken: verificationToken });
  },

  // ---------------------------------------------------------------------------
  // PASSWORD & SESSION FLOWS
  // ---------------------------------------------------------------------------

  async forgotPassword({ email }) {
    return sendRequest("password/reset/init", { Email: email });
  },

  async resetPassword({ token, newPassword }) {
    return sendRequest("password/reset/complete", {
      Token: token,
      NewPasswordHash: newPassword
    });
  },

  async revoke({ SessionId }) {
    // Critical: Matches C# RevokeRequest { SessionId }
    return sendRequest("signout", { SessionId: SessionId });
  },

  async signOut({ sessionId }) {
    return this.revoke({ SessionId: sessionId });
  }
};